import React from 'react';


const ManagerCustomerStatusCard = ({ icon, activeNumber, customerText, noOfCustomers, customers, noOfOrdersClassName, dropDown}) => {



    return (
        <section>
            <div className='order-status-card-container manager-customer-status-card'>
                <div className='flex gap-4'>
                    <div>{icon}</div>
                    <p className='due-text'>{customerText}</p>
                    <section>
                        
                        {dropDown}
                    </section>
                </div>
                <div className='flex flex-col gap-20 mt-7'>
                    <div>
                        <p className={`no-of-orders ${noOfOrdersClassName}`}>{noOfCustomers} <span className='orders-text'>{customers}</span> </p>
                    </div>
                    
                </div>
                <div className='customer-active-section'>
                    <p className='size mt-2'>{activeNumber} <span className='customer-active-text'>active this month</span> </p>
                </div>
            </div>
        </section>
    );
}

export default ManagerCustomerStatusCard;
